const MANIFEST_BY_PREFIX = [
  { prefix: "/manage/app", href: "/manifest-admin.json" },
  { prefix: "/staff/app", href: "/manifest-staff.json" },
  { prefix: "/app", href: "/manifest-client.json" },
];

export function applyPwaManifest(pathname = window.location.pathname) {
  if (typeof document === "undefined") return;
  const match =
    MANIFEST_BY_PREFIX.find((item) => pathname.startsWith(item.prefix)) ||
    MANIFEST_BY_PREFIX[2];
  let link = document.querySelector('link[rel="manifest"]');
  if (!link) {
    link = document.createElement("link");
    link.rel = "manifest";
    document.head.appendChild(link);
  }
  if (link.getAttribute("href") !== match.href) {
    link.setAttribute("href", match.href);
  }

  let appleIcon = document.querySelector('link[rel="apple-touch-icon"]');
  if (!appleIcon) {
    appleIcon = document.createElement("link");
    appleIcon.rel = "apple-touch-icon";
    document.head.appendChild(appleIcon);
  }
  if (appleIcon.getAttribute("href") !== "/icons/icon-192.png") {
    appleIcon.setAttribute("href", "/icons/icon-192.png");
  }
}
